import type React from 'react'
import { useEffect } from 'react'
import * as serviceWorkerRegistration from '../serviceWorkerRegistration'

// Unregistering a service worker destroys any push subscription attached
// to it, so the worker must stay registered while this browser is
// subscribed to push notifications.
const unregisterUnlessPushSubscribed = async () => {
  if (!('serviceWorker' in navigator)) {
    return
  }
  try {
    const registration = await navigator.serviceWorker.getRegistration()
    const subscription = registration
      ? await registration.pushManager.getSubscription()
      : null
    if (subscription) {
      console.log('Keeping service worker registered for push notifications')
      return
    }
  } catch {
    // fall through to the previous unregister behavior
  }
  console.log('Leaving /tags route - unregistering service worker')
  serviceWorkerRegistration.unregister()
}

const ConditionalServiceWorker: React.FC = () => {
  useEffect(() => {
    const handleRouteChange = () => {
      const isTagsRoute = window.location.pathname.startsWith('/tags')

      if (isTagsRoute) {
        console.log('Entering /tags route - registering service worker')
        serviceWorkerRegistration.register()
      } else {
        void unregisterUnlessPushSubscribed()
      }
    }

    // Check initial route
    handleRouteChange()

    // Listen for popstate events (back/forward button)
    window.addEventListener('popstate', handleRouteChange)

    // Listen for pushstate/replacestate (programmatic navigation)
    const originalPushState = window.history.pushState
    const originalReplaceState = window.history.replaceState

    window.history.pushState = (...args) => {
      originalPushState.apply(window.history, args)
      setTimeout(handleRouteChange, 0)
    }

    window.history.replaceState = (...args) => {
      originalReplaceState.apply(window.history, args)
      setTimeout(handleRouteChange, 0)
    }

    return () => {
      window.removeEventListener('popstate', handleRouteChange)
      window.history.pushState = originalPushState
      window.history.replaceState = originalReplaceState
    }
  }, [])

  return null
}

export default ConditionalServiceWorker
